import { FC, useContext } from 'react';
import { Box, Stack, Typography } from '@mui/material';

import CTAButton from '@/components/ui/CTAButton';
import NeuerStandContext from '@/utils/context/NeuerStandContext';

/**
 * Reload-Banner bei Version-Skew (Alex-Entscheid 22.07.2026,
 * docs/tasks/version-skew-frontend.md).
 *
 * Anlass: am 22.07. lief das Backend von Deploy #99 gegen Tabs, in denen noch
 * das #97-Bundle stand. Die Kontaktsuche warf dort `existing_customer`
 * undefined; 20 Tabs waren nach dem Cutover noch offen, 6 davon auf
 * /home/telefonie. Ein alter Tab heilt sich nur durch einen Reload — und ohne
 * Hinweis passiert der irgendwann, nicht absehbar.
 *
 * KEIN SOFORTIGER RELOAD: ein erzwungener Reload mitten im Buchungs-Wizard
 * verwirft den Formularzustand; der Agent haette dann den Kunden am Telefon und
 * ein leeres Formular. Seit dem Entscheid Alex 27.10.2026 laedt die App aber
 * beim NAECHSTEN SEITENWECHSEL einmal neu ({@see NeuerStandWaechter},
 * docs/tasks/auto-reload-neuer-stand.md) — bis dahin steht dieses Banner als
 * Hinweis. Das Banner selbst laedt nie von selbst neu (VersionBanner.test.tsx).
 *
 * UNAUFDRINGLICH UND OHNE UEBERDECKUNG: bewusst ein Element IM FLUSS statt
 * eines Overlays — genau wie der GoogleCalendarBanner, an dessen Mount-Stelle
 * es haengt. Ein schwebendes Element haette entweder die Toasts (fix unten
 * links) oder die primaeren Wizard-Aktionen ueberdeckt. Im Fluss kann es
 * konstruktiv nichts verdecken. Ruhige Palette (`info.flaeche`, Design-Rollout 25.10.2026) statt der
 * roten Fehlerfarbe des Kalender-Banners: das hier ist ein Hinweis, kein
 * Blocker — die Seite funktioniert weiter.
 */
const VersionBanner: FC = () => {
  // Gemessen wird EINMAL je Tab im NeuerStandWaechter (RootView); das Banner
  // liest nur das Ergebnis.
  const { updateAvailable } = useContext(NeuerStandContext);

  if (!updateAvailable) return null;

  return (
    <Box
      sx={{
        bgcolor: 'info.flaeche',
        borderBottom: '1px solid',
        borderBottomColor: 'info.rahmen',
        px: 6,
        py: 2,
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        gap={2}
        flexWrap="wrap"
      >
        <Typography variant="wertBetont">
          Neue Version verfügbar — bitte neu laden.
        </Typography>
        <CTAButton
          label="Neu laden"
          variant="outlined"
          size="small"
          autoWidth
          onClick={() => window.location.reload()}
        />
      </Stack>
    </Box>
  );
};

export default VersionBanner;
